import api from './api';

export interface TransferHistoryEntry {
  id: string;
  transferId: string;
  userId: string | null;
  userName: string | null;
  action: 'created' | 'updated' | 'status_changed' | 'assigned' | 'unassigned' | 'deleted';
  fieldName: string | null;
  oldValue: string | null;
  newValue: string | null;
  changes: Record<string, { old: any; new: any }> | null;
  createdAt: string;
}

export const transferHistoryService = {
  async getByTransferId(transferId: string): Promise<TransferHistoryEntry[]> {
    const response = await api.get(`/transfers/${transferId}/history`);
    return response.data;
  },
};
